module.exports = __webpack_public_path__ + "media/images/AjaxLoader-5b8b06c052cac80413d62e5c45f9f37b.gif";